module.exports = __webpack_public_path__ + "static/img/brad_1000.209d5b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/brad_1000.jpg
// module id = JA4+
// module chunks = 1